document.addEventListener("DOMContentLoaded", function() {
  // Get current page number from URL
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get('page')) || 1;

  // If page is greater than 1, insert meta noindex and canonical
  if (page > 1) {
    // Add <meta name="robots" content="noindex, follow">
    let meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);

    // Update canonical link
    let canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.href = window.location.pathname.replace(/\?page=\d+/, '');
    } else {
      let link = document.createElement('link');
      link.rel = 'canonical';
      link.href = window.location.pathname.replace(/\?page=\d+/, '');
      document.head.appendChild(link);
    }
  }
});
